import React from "react";

const ReviewsSection = ({ reviews }: any) => {
  const rating = reviews.overallRating;
  const totalReviews = reviews.totalReviews;
  const reviewsData = reviews.data;

  // Extract ratings from reviewsData
  const cleanlinessRating =
    reviewsData?.find((review: any) => review.name === "cleanliness")?.rating ||
    0;
  const securityRating =
    reviewsData?.find((review: any) => review.name === "security")?.rating || 0;
  const amenitiesRating =
    reviewsData?.find((review: any) => review.name === "amenities")?.rating || 0;
  const maintenanceRating =
    reviewsData?.find((review: any) => review.name === "maintainance")?.rating ||
    0;
  const valueForMoneyRating =
    reviewsData?.find((review: any) => review.name === "value_for_money")
      ?.rating || 0;

  const categories = [
    { name: "Cleanliness", rating: cleanlinessRating, icon: "🧼" },
    { name: "Security", rating: securityRating, icon: "🔒" },
    { name: "Amenities", rating: amenitiesRating, icon: "💡" },
    { name: "Maintenance", rating: maintenanceRating, icon: "🛠️" },
    { name: "Value for money", rating: valueForMoneyRating, icon: "💰" },
  ];

  return (
    <div className="p-4 sm:p-8">
      <div className="flex items-center">
        <span className="text-yellow-500 text-xl mr-2">⭐</span>
        <span className="text-lg font-semibold">
          {rating} · {totalReviews} Reviews
        </span>
      </div>

      <div className="mt-4 grid grid-cols-1 sm:grid-cols-6 gap-4">
        {/* Overall Ratings */}
        <div className="col-span-1 flex flex-col justify-center">
          <span className="font-semibold">Overall Ratings</span>
          {[cleanlinessRating, securityRating, amenitiesRating, maintenanceRating, valueForMoneyRating].map((level) => (
            <div key={level} className="flex items-center space-x-2">
              <span>{level}</span>
              <div className="w-full bg-gray-200 rounded h-2">
                <div
                  className={`bg-green-500 h-2 rounded`}
                  style={{ width: `${level * 20}%` }} // adjust these values based on real data
                ></div>
              </div>
            </div>
          ))}
        </div>

        {/* Categories */}
        {categories.map((category, index) => (
          <div
            key={index}
            className="col-span-1 text-center border-l border-gray-300"
          >
            <div className="text-3xl">{category.icon}</div>{" "}
            {/* Replace with actual icons */}
            <div className="font-semibold">{category.name}</div>
            <div className="text-lg">{category.rating}</div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ReviewsSection;
